import { Grid, Link, Typography } from '@material-ui/core';
import { useTranslation, Trans } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import useCommonStyles from '../../../useCommonStyles';

const SignUpFooter = () => {
    useTranslation(['signUpPage']);
    const commonStyles = useCommonStyles();
    const history = useHistory();

    const linkElement = (
        <Link
            className={commonStyles.fontWeightBold}
            color="secondary"
            component="a"
            onClick={() => history.push('/signIn')}
        >
            b
        </Link>
    );

    return (
        <Grid xs={12} item>
            <Typography align="center" className={commonStyles.primary}>
                <Trans i18nKey="signUpPage:hasAccountQuestion">a {linkElement} c</Trans>
            </Typography>
        </Grid>
    );
};

export default SignUpFooter;
